import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiError, request, requestVoid } from '@/shared/api'
import { type Session, SessionSchema, type SignInInput } from '../model/types'

export const sessionQueryKey = ['session'] as const

export const sessionQueryOptions = queryOptions({
  queryKey: sessionQueryKey,
  queryFn: async (): Promise<Session | null> => {
    try {
      return await request('/auth/me', SessionSchema)
    } catch (error) {
      // 401 — это «не вошёл», нормальное состояние гейта, а не сбой.
      if (error instanceof ApiError && error.status === 401) return null
      throw error
    }
  },
  staleTime: 60_000,
})

export function useSignInMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: SignInInput): Promise<Session> =>
      request('/auth/sign-in', SessionSchema, { method: 'POST', body: input }),
    onSuccess: (session) => {
      qc.setQueryData(sessionQueryKey, session)
      void qc.invalidateQueries()
    },
  })
}

export function useSignOutMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (): Promise<void> => requestVoid('/auth/sign-out', { method: 'POST' }),
    onSuccess: () => {
      qc.setQueryData(sessionQueryKey, null)
      void qc.invalidateQueries()
    },
  })
}
